/**
 * The Enemy's seal: stamped in ink, or glowing red on a screen.
 */

/** Uneven ink, for the stamped seal. */
const INK_MASK =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='2' seed='4'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -1.5 1.55'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")";

/** The Enemy's seal: an eye that never closes, a ring cracked through, their
 *  name round the bottom. */
export function EnemyMark({
  className = "",
  tone = "ink",
}: {
  className?: string;
  /** "ink": stamped on paper; "screen": glowing red on a display */
  tone?: "ink" | "screen";
}) {
  return (
    <svg
      viewBox="0 0 200 200"
      aria-label="The Enemy's seal"
      style={
        tone === "ink"
          ? { maskImage: INK_MASK, WebkitMaskImage: INK_MASK }
          : undefined
      }
      className={`pointer-events-none ${
        tone === "ink"
          ? "text-[#1d1715] opacity-85 mix-blend-multiply"
          : "text-[#ff2a1f] [filter:drop-shadow(0_0_6px_#ff2a1f)_drop-shadow(0_0_18px_rgba(255,42,31,.6))]"
      } ${className}`}
    >
      <defs>
        <path id="emBot" d="M31 100a69 69 0 0 0 138 0" />
      </defs>
      <g fill="none" stroke="currentColor">
        <circle cx="100" cy="100" r="94" strokeWidth="5" />
        <circle cx="100" cy="100" r="54" strokeWidth="3" />
        {/* the crack through the rings */}
        <path
          d="M128 6l-9 22 8 6-12 20"
          strokeWidth="3"
          strokeLinejoin="bevel"
        />
      </g>
      <g
        fontFamily="Saira Stencil One, Impact, sans-serif"
        fontSize="24"
        letterSpacing="5"
        fill="currentColor"
        textAnchor="middle"
      >
        <text>
          <textPath href="#emBot" startOffset="50%" dominantBaseline="hanging">
            THE ENEMY
          </textPath>
        </text>
      </g>
      {/* the eye: almond, slit pupil, rays round it */}
      <path
        d="M58 100q42-34 84 0q-42 34-84 0z"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
      />
      <ellipse cx="100" cy="100" rx="6" ry="16" fill="currentColor" />
      {Array.from({ length: 8 }, (_, i) => (
        <line
          key={i}
          x1="100"
          y1="58"
          x2="100"
          y2="66"
          stroke="currentColor"
          strokeWidth="3"
          transform={`rotate(${-70 + i * 20} 100 100)`}
        />
      ))}
    </svg>
  );
}
